export default __webpack_public_path__ + "static/media/Counter_Number.cfbf646b.mp3";